import { createServerFn } from "@tanstack/react-start";
import {
  getAdminEmails,
  isAdminConfigured,
  isAdminEmail,
} from "~/lib/admin/auth";
import { authMiddleware } from "~/lib/auth/middleware";

export const $checkAdminAccess = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    const allowed = isAdminEmail(context.user.email);

    if (!allowed) {
      const admins = getAdminEmails();
      console.warn(
        "[admin] Access denied",
        JSON.stringify({
          userEmail: context.user.email,
          adminCount: admins.length,
          configured: isAdminConfigured(),
        }),
      );
    }

    return allowed;
  });

/** Session email + whether ADMIN_EMAILS is set (for troubleshooting). */
export const $getAdminAccessInfo = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => ({
    email: context.user.email,
    isAdmin: isAdminEmail(context.user.email),
    adminConfigured: isAdminConfigured(),
  }));
